export enum ReasonRemoveOrder {
  INVOICE_BILLED_HIGHER = 'INVOICE_BILLED_HIGHER',
  INVOICE_BILLED_LOWER = 'INVOICE_BILLED_LOWER',
  IMPROPER_INVOICE = 'IMPROPER_INVOICE',
  PURCHASE_ORDER_HIGHER = 'PURCHASE_ORDER_HIGHER',
  PURCHASE_ORDER_LOWER = 'PURCHASE_ORDER_LOWER',
  PRIOR_TO_DEMAND = 'PRIOR_TO_DEMAND',
  OTHERS = 'OTHERS',
}
